var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-toc-container"},[_c('h2',[_vm._v("文章目录")]),_c('RightList',{attrs:{"list":_vm.tocWithAnchor},on:{"select":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }